'use strict';

import {addCustomEventListener, addClass, removeClass} from '../helpers';

export const techsList = (() => {
  let _titleList;
  let _list;
  let _techs;

  const numberingTitle = () => {
    if (!_titleList.length) {
      return false;
    }

    _titleList.forEach((_el, i) => {
      i++;
      _el.innerText = (i < 10 ? `0${i} / ` : `${i} / `) + _el.innerText;
    });
  }

  const showList = () => {
    let items = [];
    let num = 1;
    _techs.forEach((_el) => {
      if (_el.querySelectorAll('.techs_page__group__item').length) {
        const name = _el.querySelector('.techs_page__group__title').innerText;
        items.push(`<a href="#" data-link="tech${num}" class="tags__item">${name}</a>`);
        _el.setAttribute('data-tech', `tech${num}`);
        num++;
      }
    });

    _list.innerHTML = items.join('');
  };

  const eventListeners = () => {
    addCustomEventListener('.tags__item', 'click', function (e) {
      e.preventDefault();
      const link = e.target.getAttribute('data-link');
      const _tech = document.querySelector(`.techs_page__group[data-tech="${link}"]`);
      const techTop = _tech.getBoundingClientRect().top;

      window.shApp.scrollTo(techTop);
      return false;
    })
  };

  const init = () => {
    _titleList = document.querySelectorAll('.techs_page__group__title');
    _list = document.querySelector('[data-type="tech_list"]');
    _techs = document.querySelectorAll('.techs_page__group');

    numberingTitle();

    if (!_list || !_techs.length) {
      return false;
    }
    showList();
    eventListeners();
  };

  return {
    init
  }
})();
